import { Product } from '../../../../pages/FindersAndProductsPage/lib/Product';

export const PRODUCT_CATEGORY_ID = Product.CATEGORY;
